module.exports = __webpack_public_path__ + "static/sourcepanel-d5ac4a99092d9eb18848b04b68fc4fe2.png";